import { fireEvent, render, screen } from '@testing-library/react'
import HomeScreen from './HomeScreen'

jest.mock('../components/screens/homescreen/header/Header', () => () => <section aria-label='Header' />)
jest.mock('../components/screens/homescreen/conversatorio/Conversatorio', () => () => <section aria-label='Conversatorio' />)
jest.mock('../components/screens/homescreen/purpose/Purpose', () => () => <section aria-label='Purpose' />)
jest.mock('../components/screens/homescreen/purpose/InterventionAxes', () => () => <section aria-label='InterventionAxes' />)
jest.mock('../components/screens/homescreen/boletines/BoletinesTimeline', () => () => <section aria-label='BoletinesTimeline' />)
jest.mock('../components/NewsletterCTA', () => () => <section aria-label='NewsletterCTA' />)

test('renders intervention axes directly after purpose', () => {
  render(<HomeScreen />)

  expect(screen.getAllByRole('region').map((region) => region.getAttribute('aria-label'))).toEqual([
    'Header',
    'Conversatorio',
    'Purpose',
    'InterventionAxes',
    'BoletinesTimeline',
    'NewsletterCTA'
  ])
})

beforeEach(() => {
  window.sessionStorage.clear()
})

test('shows the association campaign popup after remounting in the same session', () => {
  const { unmount } = render(<HomeScreen />)
  expect(screen.queryByRole('dialog')).toBeNull()
  unmount()

  render(<HomeScreen showAssociationCampaignPopup />)

  expect(screen.getByText('CAMPAÑA AMIGAS 2026–2027')).toBeTruthy()
  expect(screen.getByRole('heading', { name: '¡Queremos contar contigo!' })).toBeTruthy()
  expect(screen.getByText('Hazte Amiga de la cultura menstrual y cíclica')).toBeTruthy()
  expect(screen.getByText(/Necesitamos tu apoyo para seguir cuidando/)).toBeTruthy()
  expect(screen.getByText('Hazte Amiga por 26 € al año y ayúdanos a mantener viva La Vida en Rojo.')).toBeTruthy()
  expect(screen.getByRole('link', { name: 'Quiero hacerme Amiga' }).getAttribute('href')).toBe(
    'https://www.lavidaenrojo.org/hazte-amiga'
  )

  fireEvent.click(screen.getByRole('button', { name: 'Cerrar aviso' }))
  expect(screen.queryByRole('dialog')).toBeNull()

  unmount()
  render(<HomeScreen showAssociationCampaignPopup />)
  expect(screen.getByRole('dialog')).toBeTruthy()
})

test('shows the association campaign popup even if previously seen in this session', () => {
  window.sessionStorage.setItem('association-campaign-seen:amigas-2026-2027', 'true')

  render(<HomeScreen showAssociationCampaignPopup />)
  expect(screen.getByRole('dialog')).toBeTruthy()
})

test('closes the association campaign popup with Escape', () => {
  render(<HomeScreen showAssociationCampaignPopup />)

  fireEvent.keyDown(document, { key: 'Escape' })

  expect(screen.queryByRole('dialog')).toBeNull()
})
